<template>
  <div
    class="appointment-filter-list"
    data-qa="appointment-type-filter-list"
  >
    <v-chip-group
      v-model="filterType"
      class="mt-2"
      mandatory
    >
      <template v-for="placeType in placeTypes">
        <v-chip
          :key="placeType"
          :value="placeType"
          outlined
          active-class="primary"
          class="appointment-filter-list__chip"
          data-qa="appointment-type-filter-list__chip"
          @click="handleFilterTabClick"
        >
          {{ t(CHIP_LABELS[placeType], options) }}
        </v-chip>
      </template>
    </v-chip-group>
  </div>
</template>

<script setup>
import I18NextVue from 'i18next'
import { nextTick } from 'vue'
import { storeToRefs } from 'pinia'
import { dispatchCustomEventGlobally } from 'www/utils'
import { useDoctorPageLpuListStore } from 'www/vue_components/common/DoctorPageLpuList/stores'

defineProps({
  placeTypes: {
    type: Array,
    default: () => [],
  },
})

const { t, language } = I18NextVue
const options = { ns: language }

const CHIP_LABELS = {
  clinic: 'В клинику',
  home: 'На дом',
  telemed: 'На онлайн-консультацию',
}

const doctorPageLpuListStore = useDoctorPageLpuListStore()
const { filterType, expandedPanels } = storeToRefs(doctorPageLpuListStore)

async function handleFilterTabClick() {
  await nextTick()

  if (window.MOBILE_VERSION) {
    expandedPanels.value = [0]
  } else {
    dispatchCustomEventGlobally('doctor-page-lpu-list:updated')
  }
}
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.appointment-type-filter-list {
  &__chip {
    margin-top: 0;
    margin-bottom: 0;
    height: 40px;
    border-radius: 87px;
    color: $ui-kit-bg-gray-0;

    &.v-chip--active {
      color: $ui-kit-primary;
    }
  }
}

.appointment-filter-list {
  &__chip {
    border-color: $ui-kit-bg-gray-80;

    &.v-chip--active {
      color: $ui-kit-primary;
    }
  }
}

:deep(.v-slide-group__content) {
  padding: 0;
}
</style>
